import { liveTicker } from '@/mocks/news';

export default function LiveTicker() {
  const loop = [...liveTicker, ...liveTicker];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center h-11 md:h-12 gap-3">
          <span className="hidden sm:flex items-center gap-2 shrink-0 pr-3 border-r border-background-50/20">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse-dot"></span>
            <span className="text-xs tracking-widest text-accent-300 whitespace-nowrap">
              正在滚动
            </span>
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track flex w-max items-center">
              {loop.map((item, index) => (
                <span
                  key={`ticker-${index}`}
                  className="flex items-center text-xs md:text-sm text-background-100/90 whitespace-nowrap"
                >
                  <span className="px-4">{item}</span>
                  <i className="ri-separator text-accent-400" aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>
          <a
            href="#flash"
            className="hidden md:flex items-center gap-1 shrink-0 pl-3 border-l border-background-50/20 text-xs text-accent-300 hover:text-accent-200 cursor-pointer whitespace-nowrap"
          >
            全部快讯
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </div>
  );
}